// @flow

export const CellDataTypes = Object.freeze({
    LatLng: 'LatLng',
    Image: 'Image',
    Date: 'Date',
    DateTime: 'DateTime',
    HumanizedTime: 'HumanizedTime',
    Distance: 'Distance',
    Percentage: 'Percentage',
    Number: 'Number',
    Time: 'Time'
});

export type EntityCellDataTypesEnumType = $Values<typeof CellDataTypes>;
